import { useEffect, useState } from "react";
import { IRenter } from "../../../../../../../../types/renter.type"
import { getRenterPayments } from "../../../../../../../../common/services/payments.api";
import { useToastContext } from "../../../../../../../../common/components/ui/toast/toast.context";
import { differenceInDays } from "date-fns";
import { formatDate } from "../../../../../../../../common/helpers/date.helpers";
import { PaymentInfo } from "@/types/payment.type";

type PorpsChangeStatusRenter = {
  renter: IRenter
}

export function useChangeStatus({ renter }: PorpsChangeStatusRenter) {
  const { notifyError } = useToastContext();
  const [disabledForPayment, setDisabledForPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [disabledToDateRepossession, setDisabledToDateRepossession] = useState(false);
  const [cancelDate, setCancelDate] = useState<Date | null>(null);
  const [payments, setPayments] = useState<PaymentInfo[]>([]);

  useEffect(() => {
    async function verifyUserStatus(renterId: string) {
      setIsLoading(true);

      try {
        // 1. Verificar pagamentos pendentes
        if (renterId) {
          const { data } = await getRenterPayments(renterId);

          if (data.length > 0) {
            const paymentStatus = data.map((payment) => payment.status);
            const hasPendingPayment = paymentStatus.some(
              (status) => status === "OVERDUE" || status === "DUNNING_REQUESTED"
            );
            const validPayments = data.filter(payment => payment.status !== 'Inativo' && payment.status !== 'RECEIVED');

            if (hasPendingPayment) {
              setDisabledForPayment(true);
              setPayments(validPayments)
            }
          }
        }

        // 2. Verificar histórico de veículos e rescisão
        if (!renter?.activationData?.vehicle?.id) {
          const vehicleHistory = renter?.desactivationData?.vehicleHistory


          if (vehicleHistory && vehicleHistory.length > 0) {
            const historyEndDate = vehicleHistory[vehicleHistory.length - 1].vehicleHistoryEnd;
            setCancelDate(historyEndDate)

            const rescisionDaysLeft = differenceInDays(new Date(), new Date(historyEndDate));
            if (rescisionDaysLeft < 10) {
              setDisabledToDateRepossession(true);
            }

          }
        }
      } catch (error) {
        notifyError("Erro ao verificar status do cliente");
      } finally {
        setIsLoading(false);
      }
    }

    if (renter._id) {
      verifyUserStatus(renter._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renter._id, renter?.activationData?.vehicle?.id, renter?.desactivationData?.vehicleHistory]);

  return {

    disabledToDateRepossession,
    isLoading,
    disabledForPayment,
    formattedDate: formatDate(new Date(cancelDate ?? new Date())),
    payments
  }

}